var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from "react";
import Icon from "../icons/Icon";
import { StyledButton } from "./Button.style";
import useButtonProps from "./useButtonProps";
import mergeProps from "../../utils/mergeProps";
const Button = forwardRef(function Button(defaultProps, ref) {
    const { size = "medium", variant = "primary", pressed = false, selected = false, iconName, children, onClick } = defaultProps, rest = __rest(defaultProps, ["size", "variant", "pressed", "selected", "iconName", "children", "onClick"]);
    const props = useButtonProps(defaultProps);
    return (React.createElement(StyledButton, Object.assign({ ref: ref, "$size": size, "$variant": variant, "$pressed": pressed && !props.disabled, "$selected": selected && !props.disabled, "$hasIcon": Boolean(iconName), "data-focus-border": true }, mergeProps(rest, props)),
        iconName && React.createElement(Icon, { name: iconName, style: { fontSize: "1rem" } }),
        children && React.createElement("span", null, children)));
});
export default Button;
//# sourceMappingURL=Button.js.map